module.exports = __webpack_public_path__ + "static/media/illustrations-car-spinner-24.da92f16f.gif";